import { LOGIN_STATE } from '../constants';
import { Actions as NotificationActions } from '../actions/notification';
import { Actions as UserActions } from '../actions/user';

export function userReducer(state = null, { payload, type } = {}) {
    switch (type) {
        case UserActions.GET_USER_SUCCESS: {
            return { ...payload.user };
        }

        case UserActions.GET_USER_FAILURE: {
            return {
                login_state: LOGIN_STATE.LoggedOut,
            };
        }

        case NotificationActions.MARK_NOTIFICATIONS_SEEN_SUCCEEDED: {
            return {
                ...state,
                unseen_notification_count: 0,
                notifications: state.notifications.map(notification => ({
                    ...notification,
                    seen: true,
                })),
            };
        }

        default: {
            return state;
        }
    }
}
